/* eslint-disable */
import React, { useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
    User,
    FileText,
    Database,
    Sun,
    Moon,
    LogOut,
    HelpCircle,
} from 'lucide-react'
import { logout } from '../../redux'
import './ProfilePopover.css'

function ProfilePopover({ isOpen, onClose, user }) {
    const dispatch = useDispatch()
    const themeMode = useSelector((state) => state.theme?.mode || 'light')
    const popoverRef = useRef(null)

    useEffect(() => {
        if (!isOpen) return

        const handleOutsideClick = (event) => {
            if (event.target.closest('#avatarBtn')) {
                return
            }
            if (
                popoverRef.current &&
                !popoverRef.current.contains(event.target)
            ) {
                onClose()
            }
        }

        document.addEventListener('click', handleOutsideClick, true)
        return () => {
            document.removeEventListener('click', handleOutsideClick, true)
        }
    }, [isOpen, onClose])

    const toggleTheme = () => {
        dispatch({ type: 'TOGGLE_THEME_MODE' })
    }

    const handleLogout = () => {
        dispatch(logout())
        onClose()
    }

    const name = user
        ? `${user.firstName || ''} ${user.lastName || ''}`.trim() ||
          user.name ||
          'User Profile'
        : 'User Profile'
    const email = user?.email || 'user@example.com'

    const getInitials = (nameStr) => {
        if (!nameStr || nameStr === 'User Profile') return 'UP'
        const parts = nameStr.split(' ').filter(Boolean)
        if (parts.length === 0) return 'UP'
        if (parts.length === 1) return parts[0][0].toUpperCase()
        return (parts[0][0] + parts[1][0]).toUpperCase()
    }

    return (
        <div
            ref={popoverRef}
            id="profilePopover"
            className={isOpen ? 'open' : ''}
            onClick={(e) => e.stopPropagation()}
        >
            <div className="popover-header">
                <div className="popover-avatar-initials">
                    {getInitials(name)}
                </div>
                <div className="popover-user-info">
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <span className="popover-user-name">{name}</span>
                        {(user?.role === 'Instructor' ||
                            String(user?.role || '').toUpperCase() ===
                                'ADMIN') && (
                            <span className="popover-instructor-tag">
                                {String(user?.role || '').toUpperCase() ===
                                'ADMIN'
                                    ? 'ADMIN'
                                    : 'Instructor'}
                            </span>
                        )}
                    </div>
                    <span className="popover-user-email">{email}</span>
                </div>
            </div>
            <div className="popover-menu">
                <Link
                    className="popover-menu-item"
                    onClick={onClose}
                    to="/myprofile"
                >
                    <User />
                    <span>My Profile</span>
                </Link>
                <Link
                    className="popover-menu-item"
                    onClick={onClose}
                    to="/notes"
                >
                    <FileText />
                    <span>My Notes</span>
                </Link>
                <Link
                    className="popover-menu-item"
                    onClick={onClose}
                    to="/question-creator-dashboard"
                >
                    <Database />
                    <span>My Question Bank</span>
                </Link>

                <div className="popover-divider" />

                <button
                    className="popover-menu-item"
                    onClick={toggleTheme}
                    type="button"
                >
                    {themeMode === 'light' ? (
                        <>
                            <Moon />
                            <span>Dark Mode</span>
                        </>
                    ) : (
                        <>
                            <Sun />
                            <span>Light Mode</span>
                        </>
                    )}
                </button>

                <button
                    className="popover-menu-item"
                    onClick={() => {
                        window.dispatchEvent(new CustomEvent('show-tutorial'))
                        onClose()
                    }}
                    type="button"
                >
                    <HelpCircle />
                    <span>Website Guide</span>
                </button>

                <div className="popover-divider" />
            </div>
            <div className="popover-footer">
                <button
                    className="popover-menu-item logout"
                    onClick={handleLogout}
                    type="button"
                >
                    <LogOut />
                    <span>Logout</span>
                </button>
            </div>
        </div>
    )
}

export default ProfilePopover
